import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { label: "ABOUT", to: "/about" },
  { label: "PODCAST", to: "/podcast" },
  { label: "SHOP", to: "/shop" },
  { label: "CONTACT", to: "/contact" },
];

const SOCIALS = [
  {
    name: "Instagram",
    href: "https://instagram.com/thatsgirlcodepod",
    Icon: InstagramIcon,
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@thatsgirlcodepod",
    Icon: TikTokIcon,
  },
  {
    name: "X",
    href: "https://x.com/thatsgirlcodepd",
    Icon: XIcon,
  },
  {
    name: "Spotify",
    href: "https://open.spotify.com/show/6eDM2coAkTGam11bhZts0G",
    Icon: SpotifyIcon,
  },
  {
    name: "Apple Podcasts",
    href: "https://podcasts.apple.com/us/podcast/thats-girl-code/id1826327958",
    Icon: ApplePodcastsIcon,
  },
];

export default function Footer() {
  return (
    <footer style={{ background: "#0d0507" }}>
      <div
        className="flex flex-col sm:flex-row items-start gap-10 sm:gap-[12%] px-6 py-10 sm:px-[8%] sm:py-[52px] max-w-6xl mx-auto"
        style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
      >
        {/* Links column */}
        <div>
          <p
            className="font-montserrat text-dustyrose"
            style={{
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.2em",
              marginBottom: "18px",
            }}
          >
            LINKS
          </p>
          {FOOTER_LINKS.map(({ label, to }) => (
            <div key={label} style={{ marginBottom: "11px" }}>
              <Link
                to={to}
                className="font-montserrat hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dustyrose"
                style={{
                  fontSize: "12px",
                  color: "rgba(255,255,255,0.82)",
                  letterSpacing: "0.1em",
                  transition: "color 0.2s ease",
                }}
              >
                {label}
              </Link>
            </div>
          ))}
        </div>

        {/* Socials column */}
        <div>
          <p
            className="font-montserrat text-dustyrose"
            style={{
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.2em",
              marginBottom: "18px",
            }}
          >
            FOLLOW
          </p>
          <div className="flex items-center gap-3">
            {SOCIALS.map(({ name, href, Icon }) => (
              <a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={name}
                className="inline-flex items-center justify-center rounded-full hover:-translate-y-0.5 hover:bg-white/[0.06] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dustyrose"
                style={{
                  width: "38px",
                  height: "38px",
                  color: "rgba(255,255,255,0.78)",
                  transition: "color 0.2s ease, transform 0.2s ease, background-color 0.2s ease",
                }}
                onMouseEnter={(e) =>
                  ((e.currentTarget as HTMLElement).style.color = "#fff")
                }
                onMouseLeave={(e) =>
                  ((e.currentTarget as HTMLElement).style.color =
                    "rgba(255,255,255,0.78)")
                }
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* copyright bar */}
      <div
        className="px-6 py-3.5 sm:px-[8%] text-center"
        style={{ borderTop: "1px solid rgba(255,255,255,0.04)" }}
      >
        <span
          className="font-montserrat"
          style={{
            fontSize: "11px",
            color: "rgba(255,255,255,0.62)",
            letterSpacing: "0.06em",
          }}
        >
          © 2026 THAT'S GIRL CODE. Please do not git clone.
        </span>
      </div>
    </footer>
  );
}

function InstagramIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.62 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.66-.1z" />
    </svg>
  );
}

function SpotifyIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141 4.26-1.26 9.78-.6 13.5 1.68.361.181.54.78.241 1.141zm.12-3.36C15.24 8.4 8.76 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.56.3z" />
    </svg>
  );
}

function XIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

function ApplePodcastsIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 0C5.373 0 0 5.373 0 12c0 4.127 2.084 7.766 5.259 9.917l.087-3.05A9.6 9.6 0 0 1 2.4 12C2.4 6.698 6.698 2.4 12 2.4c5.302 0 9.6 4.298 9.6 9.6a9.6 9.6 0 0 1-2.946 6.917l.087 3.05C21.916 19.766 24 16.127 24 12c0-6.627-5.373-12-12-12zm0 4.8a7.2 7.2 0 0 0-4.46 12.85l.08-2.793A4.8 4.8 0 1 1 16.38 14.86l.08 2.79A7.2 7.2 0 0 0 12 4.8zm0 4.8a2.4 2.4 0 0 0-1.49 4.28L10.08 24h3.84l-.43-10.12A2.4 2.4 0 0 0 12 9.6z" />
    </svg>
  );
}
